import React, { useState } from 'react';
import './StarRating.css';

const StarRating = ({setReview}) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    // Jen uložit do db

    const onHandle = () => {
        if(rating > 0){
            console.log("click")
            setReview(rating)
        } else {
            alert("Vyberte prosím 1 až 5 hvězd podle toho, jak jste byli spokojeni.")
    
          }
        
    }
    return (
        <section className='StartRatingContainer'>
        <div className="star-rating">
            {[...Array(5)].map((star, index) => {
                index += 1;
                return (
                  
                    <button
                        type="button"
                        key={index}
                        className={index <= (hover || rating) ? "on" : "off"}
                        onClick={() => setRating(index)}
                        onMouseEnter={() => setHover(index)}
                        onMouseLeave={() => setHover(rating)}
                    >
                        <span className="star">&#9733;</span>
                    </button>
                 
                );
            })}
            
        </div>
        <button className='btnReview' onClick={onHandle}>Odeslat Váš názor</button>
        </section>
    );
};

export default StarRating;
